export const formatNumber = (value: number) => value.toLocaleString('uk-UA');
